import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Response } from "@angular/http";

import { BaseWebService } from "../shared/services/base-web.service";
import { SessionStorageService } from "../shared/services/session-storage.service";
import { config } from "../../../config/index";
import "rxjs/add/observable/throw";

@Injectable()
export class LoginService {
    private _STORAGE_KEY = config.storage_key;
    private _role = config.role;
    private _menuList = config.menu_list;
    private language = config.language;
    private package = config.package;
    private country = config.country;

    constructor(
        private _baseWebService: BaseWebService,
        private _sessionStorageService: SessionStorageService
    ) { }

	/**
	 * service function for login.
	 * @param  {any} loginData contains username and password.
	 * @returns Observable
	 */
    login = (loginData: any): Observable<any> => {
        const data: any = {};
        data.body = loginData;
        return this._baseWebService
            .request("v1/login/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    };

	/**
	 * function to save api token for login in localforage.
	 * @param  {any} data api token.
	 */
    saveToken = async (key: string, data: any) => {
        try {
            if (key === "storage_key") {
                await this._sessionStorageService.saveItem(this._STORAGE_KEY, data);
            } else if (key === "role") {
                await this._sessionStorageService.saveItem(this._role, data);
            } else if (key === "menu_list") {
                await this._sessionStorageService.saveItem(this._menuList, data);
            } else if (key === "language") {
                await this._sessionStorageService.saveItem(this.language, data);
            } else if (key === "subscription") {
                await this._sessionStorageService.saveItem(this.package, data);
            } else if (key === "country") {
                await this._sessionStorageService.saveItem(this.country, data);
            } else if (key === "practice_country_key") {
                await this._sessionStorageService.saveItem(key, data);
            }
        } catch (error) {
            return error;
        }
    };

	/**
	 * service function for login.
	 * @param  {any} loginData contains username and password.
	 * @returns Observable
	 */
    forgotPassword = (username: any): Observable<any> => {
        const data: any = {};
        data.body = { username: username };
        return this._baseWebService
            .request("v1/recover_password/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    };

	/**
	 * function for login success.
	 * @param  {Response} res success response.
	 */
    private extractData(res: Response) {
        return res.json();
    }

	/**
	 * function for login error.
	 * @param  {Response|any} error error response.
	 */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}
